const navToggle = document.querySelector('[data-nav-toggle]');
const nav = document.querySelector('[data-nav]');

if (navToggle && nav) {
  navToggle.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('nav-is-open', isOpen);
  });
}

document.querySelectorAll('.nav-item-anime').forEach((item) => {
  let closeTimer = null;

  const openMenu = () => {
    window.clearTimeout(closeTimer);
    item.classList.add('is-mega-open');
  };

  const closeMenu = () => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      item.classList.remove('is-mega-open');
    }, 280);
  };

  item.addEventListener('pointerenter', openMenu);
  item.addEventListener('pointerleave', closeMenu);
  item.addEventListener('focusin', openMenu);
  item.addEventListener('focusout', closeMenu);
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('.hero-carousel-track');
  const slides = track ? Array.from(track.querySelectorAll('.hero-banner-slide')) : [];
  const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
  if (!track || slides.length < 2) return;

  let activeIndex = 0;
  let timer = null;
  let scrollTimer = null;

  const setActive = (index) => {
    activeIndex = Math.max(0, Math.min(slides.length - 1, index));
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === activeIndex);
    });
  };

  const goTo = (index) => {
    const nextIndex = (index + slides.length) % slides.length;
    track.scrollTo({ left: slides[nextIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setActive(nextIndex);
  };

  const start = () => {
    if (timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timer = window.setInterval(() => goTo(activeIndex + 1), 4200);
  };

  const stop = () => {
    window.clearInterval(timer);
    timer = null;
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      stop();
      goTo(Number(dot.dataset.heroDot || 0));
      start();
    });
  });

  track.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const nextIndex = slides.reduce((closestIndex, slide, index) => {
        const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
        const closestDistance = Math.abs(slides[closestIndex].offsetLeft - track.scrollLeft);
        return currentDistance < closestDistance ? index : closestIndex;
      }, activeIndex);
      setActive(nextIndex);
    }, 80);
  }, { passive: true });

  carousel.addEventListener('pointerenter', stop);
  carousel.addEventListener('pointerleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);
  start();
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const productId = form.getAttribute('data-product-form');
  const data = document.querySelector(`[data-variant-data="${productId}"]`);
  const idInput = form.querySelector('input[name="id"]');

  if (!data || !idInput) return;

  const variants = JSON.parse(data.textContent);
  const optionInputs = form.querySelectorAll('input[name^="options["]');

  form.addEventListener('change', () => {
    const selectedOptions = [];

    optionInputs.forEach((input) => {
      if (input.checked) selectedOptions.push(input.value);
    });

    const matchedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (matchedVariant) {
      idInput.value = matchedVariant.id;
    }
  });
});

const revealItems = document.querySelectorAll('.reveal');

if ('IntersectionObserver' in window && revealItems.length) {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.16 });

  revealItems.forEach((item) => revealObserver.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('[data-size-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const extraSizes = button.nextElementSibling;
    if (!extraSizes) return;

    const isHidden = extraSizes.hasAttribute('hidden');
    extraSizes.toggleAttribute('hidden', !isHidden);
    const label = button.querySelector('span');
    if (label) {
      label.textContent = isHidden ? 'Nascondi taglie' : 'Altre taglie disponibili';
    }
  });
});

document.querySelectorAll('[data-address-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const targetId = button.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    const isOpening = target.hasAttribute('hidden');
    target.toggleAttribute('hidden', !isOpening);
    button.setAttribute('aria-expanded', String(isOpening));
    button.textContent = isOpening ? 'Chiudi' : 'Modifica';
  });
});

document.querySelectorAll('form[data-confirm-message]').forEach((form) => {
  form.addEventListener('submit', (event) => {
    const message = form.getAttribute('data-confirm-message') || 'Confermare questa azione?';
    if (!window.confirm(message)) event.preventDefault();
  });
});

const showCartToast = (message = 'Il prodotto è stato aggiunto correttamente.', title = 'Aggiunto al carrello') => {
  const toast = document.querySelector('[data-cart-toast]');
  const heading = document.querySelector('[data-cart-toast-title]');
  const text = document.querySelector('[data-cart-toast-text]');

  if (!toast) return;
  if (heading) heading.textContent = title;
  if (text) text.textContent = message;

  toast.classList.add('is-visible');
  window.clearTimeout(showCartToast.timeout);
  showCartToast.timeout = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 2600);
};

document.querySelectorAll(
  '.product-media img, .product-gallery img, .cart-item-media img, .hero-product img, .collection-tile img'
).forEach((image) => {
  image.setAttribute('draggable', 'false');
  image.addEventListener('dragstart', (event) => {
    event.preventDefault();
    event.stopPropagation();
  });
  image.addEventListener('contextmenu', (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showCartToast('Il download diretto delle immagini è disattivato.', 'Immagine protetta');
  });
});

const protectAjaxProductImage = (image) => {
  if (!image || image.dataset.ajaxImageProtected === 'true') return;
  image.dataset.ajaxImageProtected = 'true';
  image.setAttribute('draggable', 'false');
  image.addEventListener('dragstart', (event) => {
    event.preventDefault();
    event.stopPropagation();
  });
  image.addEventListener('contextmenu', (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showCartToast('Il download diretto delle immagini e disattivato.', 'Immagine protetta');
  });
};

const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
}[char]));

const formatProductPrice = (price) => {
  const number = Number(price);
  if (Number.isNaN(number)) return '';
  return number.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
};

const renderAjaxProductCard = (product) => {
  const title = escapeHtml(product.title || 'T-shirt Bazinga Nerd Shop');
  const handle = product.handle || '';
  const root = window.Shopify?.routes?.root || '/';
  const productUrl = `${root}products/${encodeURIComponent(handle)}`;
  const image = product.images?.[0]?.src || product.image?.src || '';
  const price = formatProductPrice(product.variants?.[0]?.price);
  const imageMarkup = image
    ? `<img src="${escapeHtml(image)}" loading="lazy" alt="${title}">`
    : `<span class="product-image-fallback">${title}</span>`;

  return `
    <article class="product-card product-card-ajax" data-product-card data-product-handle="${escapeHtml(handle)}">
      <a class="product-media" href="${productUrl}">
        ${imageMarkup}
        <span class="product-badge">Spedizione gratis</span>
      </a>
      <div class="product-info">
        <a href="${productUrl}" class="product-title">${title}</a>
        <div class="product-price"><span>${price}</span></div>
      </div>
    </article>
  `;
};

const handleizeText = (value = '') => String(value)
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const productMatchesRailFilter = (product, filterTags) => {
  if (!filterTags.length) return true;

  const productTokens = [
    ...(product.tags || []),
    product.product_type || '',
    product.vendor || ''
  ].map(handleizeText).filter(Boolean);

  return filterTags.some((filterTag) => {
    return productTokens.some((productToken) => productToken === filterTag || productToken.includes(filterTag));
  });
};

const setupInfiniteProductRail = (rail) => {
  if (rail.dataset.infiniteReady === 'true') return;

  const mode = rail.dataset.infiniteMode || 'mobile-2x2';
  if (mode === 'mobile-2x2' && !window.matchMedia('(max-width: 760px)').matches) return;

  rail.dataset.infiniteReady = 'true';

  const collectionHandle = rail.dataset.collectionHandle || 'all';
  const pageSize = Number(rail.dataset.pageSize || 48);
  const filterTags = (rail.dataset.filterTags || '').split(',').map(handleizeText).filter(Boolean);
  const loadedHandles = new Set();
  let page = 1;
  let loading = false;
  let done = false;
  let replacedFallback = false;

  const productEndpoint = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}collections/${encodeURIComponent(collectionHandle)}/products.json?limit=${pageSize}&page=${page}&sort_by=created-descending`;
  };

  const appendProducts = (products) => {
    const fragment = document.createDocumentFragment();
    let appended = 0;

    products.forEach((product) => {
      if (!product.handle || loadedHandles.has(product.handle)) return;
      loadedHandles.add(product.handle);

      const wrapper = document.createElement('div');
      wrapper.innerHTML = renderAjaxProductCard(product).trim();
      const card = wrapper.firstElementChild;
      if (!card) return;
      card.querySelectorAll('img').forEach(protectAjaxProductImage);
      fragment.appendChild(card);
      appended += 1;
    });

    rail.appendChild(fragment);
    return appended;
  };

  const loadProducts = async () => {
    if (loading || done) return;

    loading = true;
    rail.setAttribute('aria-busy', 'true');

    try {
      let addedThisRun = 0;
      let attempts = 0;

      while (!done && addedThisRun === 0 && attempts < 5) {
        attempts += 1;
        const response = await fetch(productEndpoint(), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('products load failed');

        const data = await response.json();
        const products = (data.products || []).sort((first, second) => {
          return new Date(second.created_at || 0) - new Date(first.created_at || 0);
        });

        page += 1;

        if (!products.length) {
          done = true;
          break;
        }

        const filteredProducts = products.filter((product) => productMatchesRailFilter(product, filterTags));

        if (filteredProducts.length && !replacedFallback) {
          rail.innerHTML = '';
          rail.scrollLeft = 0;
          loadedHandles.clear();
          replacedFallback = true;
        }

        addedThisRun += appendProducts(filteredProducts);
        if (products.length < pageSize) done = true;
      }
    } catch (error) {
      done = true;
    } finally {
      loading = false;
      rail.removeAttribute('aria-busy');
    }
  };

  rail.addEventListener('scroll', () => {
    const remaining = rail.scrollWidth - rail.scrollLeft - rail.clientWidth;
    if (remaining < rail.clientWidth * 1.4) loadProducts();
  }, { passive: true });

  loadProducts();
};

const initInfiniteProductRails = () => {
  document.querySelectorAll('[data-infinite-products]').forEach(setupInfiniteProductRail);
};

initInfiniteProductRails();
window.addEventListener('resize', initInfiniteProductRails);

const updateCustomPrintSize = (size) => {
  const preview = document.querySelector('.shirt-preview');
  if (!preview) return;

  const isSmallKids = ['3-4', '5-6'].includes(size);
  const printNotes = preview.querySelectorAll('[data-print-note]');

  preview.classList.toggle('is-small-kids-print', isSmallKids);

  printNotes.forEach((printNote) => {
    printNote.textContent = isSmallKids
      ? 'Area stampa kids: più piccola delle taglie adulto'
      : 'Area stampa max 25 x 33 cm';
  });
};

const getSelectedShirtColor = () => {
  return document.querySelector('[data-shirt-color].is-selected')?.dataset.shirtColor
    || document.querySelector('[data-shirt-color-input]')?.value
    || 'Nero';
};

const getSelectedPrintPosition = () => {
  return document.querySelector('[data-print-position]')?.value || 'Fronte';
};

const setShirtBaseImage = (image, color) => {
  if (!image) return;

  const side = image.dataset.shirtBase || 'front';
  const nextImage = color === 'Bianco' ? image.dataset.shirtWhite : image.dataset.shirtBlack;

  if (nextImage) image.src = nextImage;
  image.alt = `${side === 'back' ? 'Retro' : 'Fronte'} T-shirt ${color.toLowerCase()} personalizzabile`;
};

const underwearModelKey = (model = 'Mutanda') => {
  if (model === 'Brasiliana') return 'brasiliana';
  if (model === 'Perizoma') return 'perizoma';
  return 'mutanda';
};

const updateUnderwearPrintPositionAvailability = (model = 'Mutanda') => {
  const select = document.querySelector('[data-underwear-print-position]');
  if (!select) return;

  const allowsBack = underwearModelKey(model) === 'mutanda';

  select.querySelectorAll('option').forEach((option) => {
    option.disabled = !allowsBack && option.value !== 'Fronte';
  });

  if (!allowsBack && select.value !== 'Fronte') {
    select.value = 'Fronte';
  }

  const note = document.querySelector('[data-underwear-position-note]');
  if (note) {
    note.textContent = allowsBack
      ? 'Puoi stampare fronte, retro oppure fronte e retro sulla mutanda.'
      : 'Su brasiliana e perizoma la personalizzazione è disponibile solo fronte.';
  }
};

const setUnderwearModel = (model = 'Mutanda') => {
  const key = underwearModelKey(model);
  const preview = document.querySelector('[data-underwear-preview]');
  const modelInput = document.querySelector('[data-underwear-model-input]');

  if (modelInput) modelInput.value = model;
  updateUnderwearPrintPositionAvailability(model);

  document.querySelectorAll('[data-underwear-model-label]').forEach((label) => {
    label.textContent = `${label.dataset.labelPrefix || ''}${model}`;
  });

  if (preview) {
    preview.classList.toggle('is-model-mutanda', key === 'mutanda');
    preview.classList.toggle('is-model-brasiliana', key === 'brasiliana');
    preview.classList.toggle('is-model-perizoma', key === 'perizoma');
  }

  document.querySelectorAll('[data-underwear-base]').forEach((image) => {
    const nextImage = image.dataset[`underwear${key.charAt(0).toUpperCase()}${key.slice(1)}`];
    if (!nextImage) return;

    image.src = nextImage;
    image.alt = `${model} nero personalizzabile`;
  });

  updateCustomPrintPosition();
};

const getActivePrintSides = () => {
  const position = getSelectedPrintPosition();
  if (position === 'Retro') return ['back'];
  if (position === 'Fronte e retro') return ['front', 'back'];
  return ['front'];
};

const updateCustomPrintPosition = () => {
  const preview = document.querySelector('[data-print-preview]');
  const form = document.querySelector('.custom-product-form');
  if (!preview) return;

  const color = getSelectedShirtColor();
  const activeSides = getActivePrintSides();
  const isBoth = activeSides.length === 2;
  const isBackOnly = activeSides.length === 1 && activeSides[0] === 'back';

  preview.classList.toggle('is-front-only', !isBoth && !isBackOnly);
  preview.classList.toggle('is-back-only', isBackOnly);
  preview.classList.toggle('is-front-back', isBoth);

  preview.querySelectorAll('[data-shirt-stage]').forEach((stage) => {
    const isActive = activeSides.includes(stage.dataset.shirtStage);
    stage.hidden = !isActive;
    stage.style.display = isActive ? '' : 'none';
  });

  preview.querySelectorAll('[data-shirt-base]').forEach((image) => {
    setShirtBaseImage(image, color);
  });

  form?.querySelectorAll('[data-upload-side]').forEach((panel) => {
    const isActive = activeSides.includes(panel.dataset.uploadSide);
    panel.hidden = !isActive;
    panel.style.display = isActive ? '' : 'none';
    panel.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = !isActive;
    });
  });

  updateCustomizationMode();
};

const setupSizeChoices = ({ root, form, variantData, sizeOptionIndex = -1 }) => {
  const variantInput = form?.querySelector('input[name="id"]');
  const choices = root.querySelectorAll('[data-size-choice]');
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const getVariantForSize = (size) => {
    if (!variants.length) return null;
    return variants.find((variant) => {
      if (!variant.available) return false;
      if (sizeOptionIndex >= 0) return variant.options[sizeOptionIndex] === size;
      return variant.options.includes(size);
    });
  };

  if (variants.length) {
    choices.forEach((choice) => {
      const selectedSize = choice.dataset.sizeChoice || choice.textContent.trim();
      const matchingVariant = getVariantForSize(selectedSize);
      choice.disabled = !matchingVariant;
      choice.classList.toggle('is-selected', matchingVariant && variantInput?.value === String(matchingVariant.id));
    });

    if (!root.querySelector('[data-size-choice].is-selected')) {
      const firstAvailableChoice = Array.from(choices).find((choice) => !choice.disabled);
      if (firstAvailableChoice) {
        firstAvailableChoice.classList.add('is-selected');
        const selectedSize = firstAvailableChoice.dataset.sizeChoice || firstAvailableChoice.textContent.trim();
        const matchingVariant = getVariantForSize(selectedSize);
        if (matchingVariant && variantInput) variantInput.value = matchingVariant.id;
        updateCustomPrintSize(selectedSize);
      }
    }
  }

  const selectedChoice = root.querySelector('[data-size-choice].is-selected');
  if (selectedChoice) {
    updateCustomPrintSize(selectedChoice.dataset.sizeChoice || selectedChoice.textContent.trim());
  }

  choices.forEach((choice) => {
    choice.addEventListener('click', () => {
      if (choice.disabled) {
        showCartToast('Questa taglia non è disponibile per questo prodotto.', 'Taglia non disponibile');
        return;
      }

      const selectedSize = choice.dataset.sizeChoice || choice.textContent.trim();
      root.querySelectorAll('[data-size-choice]').forEach((item) => {
        item.classList.remove('is-selected');
      });
      choice.classList.add('is-selected');
      updateCustomPrintSize(selectedSize);

      const matchingVariant = getVariantForSize(selectedSize);
      if (matchingVariant && variantInput) variantInput.value = matchingVariant.id;
    });
  });
};

document.querySelectorAll('.product-card').forEach((card) => {
  const form = card.querySelector('form');
  const variantData = form?.querySelector('[data-card-variant-data]');
  const sizeOptionIndex = Number(variantData?.dataset.sizeOptionIndex ?? -1);
  setupSizeChoices({ root: card, form, variantData, sizeOptionIndex });
});

document.querySelectorAll('.product-detail').forEach((productDetail) => {
  const formWrapper = productDetail.querySelector('[data-product-form]');
  const form = productDetail.querySelector('form.product-purchase-form');
  const variantData = formWrapper
    ? document.querySelector(`[data-variant-data="${formWrapper.getAttribute('data-product-form')}"]`)
    : null;
  setupSizeChoices({ root: productDetail, form, variantData });
});

const textFontFamily = (font) => {
  if (font === 'Courier New') return '"Courier New", monospace';
  if (font === 'Lucida Console') return '"Lucida Console", monospace';
  if (font === 'Arial Black') return '"Arial Black", Arial, sans-serif';
  if (font === 'Trebuchet MS') return '"Trebuchet MS", Arial, sans-serif';
  if (font === 'Bebas Neue') return '"Arial Black", Impact, sans-serif';
  if (font === 'Montserrat') return 'Montserrat, Arial, sans-serif';
  if (font === 'Oswald') return 'Oswald, "Arial Narrow", Arial, sans-serif';
  if (font === 'Comic Sans MS') return '"Comic Sans MS", cursive';
  if (font === 'Brush Script MT') return '"Brush Script MT", cursive';
  if (font === 'Garamond') return 'Garamond, Georgia, serif';
  if (font === 'Copperplate') return 'Copperplate, "Arial Black", fantasy';
  if (font === 'Franklin Gothic Medium') return '"Franklin Gothic Medium", Arial, sans-serif';
  if (font === 'Times New Roman') return '"Times New Roman", serif';
  return `${font || 'Impact'}, Arial, sans-serif`;
};

const getCustomMode = () => {
  return document.querySelector('[data-custom-mode]')?.value || 'Grafica caricata';
};

const modeNeedsGraphic = () => ['Grafica caricata', 'Grafica e testo'].includes(getCustomMode());

const modeNeedsText = () => ['Solo testo', 'Grafica e testo'].includes(getCustomMode());

const isComboMode = () => getCustomMode() === 'Grafica e testo';

const getCustomTextStyle = (side) => {
  return {
    font: document.querySelector(`[data-custom-font="${side}"]`)?.value || 'Impact',
    size: Number(document.querySelector(`[data-custom-size="${side}"]`)?.value || 100),
    width: Number(document.querySelector(`[data-custom-width="${side}"]`)?.value || 100),
    color: document.querySelector(`[data-custom-color="${side}"]`)?.value || '#00d4ff',
    align: document.querySelector(`[data-custom-align="${side}"]`)?.value || 'center'
  };
};

const updateCustomPrintAreaState = (side) => {
  const previewImage = document.querySelector(`[data-custom-preview-image="${side}"]`);
  const previewText = document.querySelector(`[data-custom-preview-text="${side}"]`);
  const textInput = document.querySelector(`[data-custom-text="${side}"]`);
  const printArea = previewText?.closest('.shirt-print-area');

  if (!printArea) return;

  printArea.classList.toggle('has-image', Boolean(previewImage?.src && !previewImage.hidden));
  printArea.classList.toggle('has-text', Boolean(textInput?.value?.trim() && modeNeedsText()));
  printArea.classList.toggle('is-combo-preview', isComboMode());
};

const updateCustomTextPreview = (side) => {
  const textInput = document.querySelector(`[data-custom-text="${side}"]`);
  const previewImage = document.querySelector(`[data-custom-preview-image="${side}"]`);
  const previewText = document.querySelector(`[data-custom-preview-text="${side}"]`);
  const sizeOutput = document.querySelector(`[data-custom-size-output="${side}"]`);
  const widthOutput = document.querySelector(`[data-custom-width-output="${side}"]`);

  if (!previewText) return;

  const hasVisibleImage = Boolean(previewImage?.src && !previewImage.hidden);
  const textEnabled = modeNeedsText();
  const value = textEnabled ? textInput?.value?.trim() || '' : '';
  const style = getCustomTextStyle(side);

  previewText.textContent = value || (textEnabled ? 'Scrivi testo' : (side === 'back' ? 'Grafica retro' : 'Grafica fronte'));
  previewText.style.fontFamily = textFontFamily(style.font);
  previewText.style.fontSize = `${style.size}%`;
  previewText.style.color = style.color;
  previewText.style.textAlign = style.align;
  previewText.style.transform = `scaleX(${style.width / 100})`;
  previewText.style.transformOrigin = 'center';
  previewText.hidden = hasVisibleImage ? !value || !isComboMode() : false;

  if (sizeOutput) sizeOutput.textContent = `${style.size}%`;
  if (widthOutput) widthOutput.textContent = `${style.width}%`;
  if (value && previewImage && !isComboMode()) previewImage.hidden = true;

  updateCustomPrintAreaState(side);
};

const wrapCanvasText = (ctx, text, maxWidth) => {
  const manualLines = text.split(/\r?\n/);
  const lines = [];

  manualLines.forEach((manualLine) => {
    const words = manualLine.split(/\s+/).filter(Boolean);
    let line = '';

    if (!words.length) {
      lines.push('');
      return;
    }

    words.forEach((word) => {
      const testLine = line ? `${line} ${word}` : word;
      if (ctx.measureText(testLine).width <= maxWidth || !line) {
        line = testLine;
        return;
      }
      lines.push(line);
      line = word;
    });

    if (line) lines.push(line);
  });

  return lines;
};

const canvasToBlob = (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/png');
  });
};

const renderTextPngFile = async (side) => {
  const text = document.querySelector(`[data-custom-text="${side}"]`)?.value?.trim();
  if (!text) return null;

  const style = getCustomTextStyle(side);
  const canvas = document.createElement('canvas');
  canvas.width = 2953;
  canvas.height = 3898;

  const ctx = canvas.getContext('2d');
  const maxWidth = canvas.width * 0.86;
  const maxHeight = canvas.height * 0.82;
  const scaleX = Math.max(style.width / 100, 0.7);
  const wrapWidth = maxWidth / Math.max(scaleX, 1);
  let fontSize = Math.round(250 * (style.size / 100));
  let lines = [];
  let lineHeight = 0;

  do {
    ctx.font = `900 ${fontSize}px ${textFontFamily(style.font)}`;
    lines = wrapCanvasText(ctx, text.toUpperCase(), wrapWidth);
    lineHeight = Math.round(fontSize * 1.12);
    if (lines.length * lineHeight <= maxHeight) break;
    fontSize -= 12;
  } while (fontSize > 72);

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = style.color;
  ctx.textAlign = style.align;
  ctx.textBaseline = 'middle';
  ctx.font = `900 ${fontSize}px ${textFontFamily(style.font)}`;
  ctx.setTransform(scaleX, 0, 0, 1, canvas.width / 2, 0);

  const textCenterY = canvas.height * 0.42;
  const startY = textCenterY - ((lines.length - 1) * lineHeight) / 2;
  const textX = style.align === 'left'
    ? -wrapWidth / 2
    : style.align === 'right'
      ? wrapWidth / 2
      : 0;
  lines.forEach((line, index) => {
    ctx.fillText(line, textX, startY + index * lineHeight);
  });

  const blob = await canvasToBlob(canvas);
  if (!blob) return null;

  return new File([blob], `testo-${side}-trasparente-25x33.png`, { type: 'image/png' });
};

// BAZINGA R2: lasciare false fino al collaudo e all'attivazione del Worker.
// Il tema continuerà a usare gli upload Shopify tradizionali finché non verrà attivato.
const BAZINGA_R2_ENABLED = true;
const BAZINGA_R2_WORKER = 'https://bazinga-upload.paganogaspare89.workers.dev';
const BAZINGA_R2_MAX_FILE_BYTES = 90000000; // 90 MB per file: limite tecnico iniziale, non compressione.

if (BAZINGA_R2_ENABLED) {
  document.querySelectorAll('[data-bazinga-r2-security]').forEach((element) => {
    element.hidden = false;
  });
  const turnstileScript = document.createElement('script');
  turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  turnstileScript.async = true;
  document.head.appendChild(turnstileScript);
}

const attachGeneratedTextPngs = async (form) => {
  const activeSides = getActivePrintSides();

  for (const side of ['front', 'back']) {
    const fileInput = form.querySelector(`[data-generated-text-file="${side}"]`);
    if (!fileInput) continue;

    if (!activeSides.includes(side)) {
      fileInput.value = '';
      continue;
    }

    if (!modeNeedsText()) {
      fileInput.value = '';
      continue;
    }

    const generatedFile = await renderTextPngFile(side);
    if (!generatedFile) {
      fileInput.value = '';
      continue;
    }

    if (!window.DataTransfer) {
      throw new Error('DataTransfer unavailable');
    }

    const transfer = new DataTransfer();
    transfer.items.add(generatedFile);
    fileInput.files = transfer.files;
  }
};

// R2: la verifica del token Turnstile viene eseguita dal Worker (/session).
// Il Worker invia i byte del File direttamente a R2: non utilizziamo canvas o WebP.
const prepareBazingaR2Uploads = async (form) => {
  const files = [];
  const activeSides = getActivePrintSides();
  for (const side of activeSides) {
    if (modeNeedsGraphic()) {
      const input = form.querySelector(`[data-custom-file="${side}"]`);
      const file = input?.files?.[0];
      if (file) files.push({ input, file, slot: `graphic-${side}` });
    }
    if (modeNeedsText()) {
      const input = form.querySelector(`[data-generated-text-file="${side}"]`);
      const file = input?.files?.[0];
      if (file) files.push({ input, file, slot: `text-${side}` });
    }
  }

  if (!files.length) throw new Error('Non riesco a preparare il file originale per R2. Ripeti il caricamento.');
  for (const item of files) {
    if (item.file.size > BAZINGA_R2_MAX_FILE_BYTES) {
      throw new Error(`Il file ${item.file.name} supera il limite tecnico di 90 MB. Contattaci per inviarlo.`);
    }
  }

  const token = form.querySelector('input[name="cf-turnstile-response"]')?.value?.trim();
  if (!token) throw new Error('Attendi il completamento della verifica Cloudflare Turnstile.');

  const sessionResponse = await fetch(`${BAZINGA_R2_WORKER}/session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      token,
      files: files.map(({ slot, file }) => ({ slot, name: file.name, size: file.size }))
    })
  });
  const sessionData = await sessionResponse.json().catch(() => ({}));
  if (!sessionResponse.ok || !sessionData.session) {
    window.turnstile?.reset?.();
    throw new Error(sessionData.error || 'Verifica di sicurezza non riuscita. Riprova.');
  }

  const saved = [];
  for (const item of files) {
    const response = await fetch(`${BAZINGA_R2_WORKER}/upload/${item.slot}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${sessionData.session}`,
        'Content-Type': item.file.type || 'application/octet-stream',
        'X-Original-Name': encodeURIComponent(item.file.name),
        'X-File-Size': String(item.file.size)
      },
      body: item.file
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result.key || result.size !== item.file.size ||
        !/^[a-f0-9]{64}$/i.test(result.sha256 || '')) {
      throw new Error(result.error || `Caricamento di ${item.file.name} non riuscito o non verificato.`);
    }
    saved.push({ ...item, key: result.key, size: result.size, sha256: result.sha256 });
  }

  // Associa all'ordine un identificativo privato. Nessun URL R2 pubblico.
  for (const item of saved) {
    const isText = item.slot.startsWith('text-');
    const side = item.slot.endsWith('front') ? 'fronte' : 'retro';
    const prefix = isText ? 'Testo PNG originale' : 'Grafica originale';
    const keyField = document.createElement('input');
    keyField.type = 'hidden';
    keyField.name = `properties[_${prefix} ${side} - R2]`;;
    keyField.value = item.key;
    form.appendChild(keyField);

    const nameField = document.createElement('input');
    nameField.type = 'hidden';
    nameField.name = `properties[Nome file ${isText ? 'testo' : 'grafica'} ${side}]`;
    nameField.value = item.file.name;
    form.appendChild(nameField);

    const sizeField = document.createElement('input');
    sizeField.type = 'hidden';
    sizeField.name = `properties[_Dimensione ${isText ? 'testo' : 'grafica'} ${side} - byte]`;
    sizeField.value = String(item.size);
    form.appendChild(sizeField);

    const hashField = document.createElement('input');
    hashField.type = 'hidden';
    hashField.name = `properties[_SHA-256 ${isText ? 'testo' : 'grafica'} ${side}]`;
    hashField.value = item.sha256;
    form.appendChild(hashField);
  }

  // Impedisce che Shopify crei una seconda copia ridotta del medesimo file.
  // Lo facciamo SOLO quando tutti gli upload R2 sono riusciti.
  for (const item of saved) item.input.removeAttribute('name');
};

const validateCustomProductForm = (form) => {
  if (!form.classList.contains('custom-product-form')) return true;

  const activeSides = getActivePrintSides();
  const sideNames = {
    front: 'fronte',
    back: 'retro'
  };
  const whatsappInput = form.querySelector('input[name="properties[_WhatsApp cliente]"]');
  const whatsappValue = whatsappInput?.value?.trim() || '';

  if (!whatsappValue) {
    showCartToast('Inserisci il numero WhatsApp: serve per confermare la grafica prima della stampa.', 'WhatsApp richiesto');
    whatsappInput?.focus();
    return false;
  }

  for (const side of activeSides) {
    const fileInput = form.querySelector(`[data-custom-file="${side}"]`);
    const textInput = form.querySelector(`[data-custom-text="${side}"]`);
    const hasFile = fileInput?.files?.length > 0;
    const hasText = Boolean(textInput?.value?.trim());

    if (modeNeedsGraphic() && !hasFile) {
      showCartToast(`Carica la grafica per il ${sideNames[side]}.`, 'Grafica mancante');
      return false;
    }

    if (modeNeedsText() && !hasText) {
      showCartToast(`Scrivi il testo per il ${sideNames[side]}.`, 'Testo mancante');
      return false;
    }

    if (isComboMode() && textInput.value.trim().length > 24) {
      showCartToast('Con grafica e testo usa una scritta breve, ad esempio un nome.', 'Testo troppo lungo');
      return false;
    }
  }

  return true;
};

const updateCustomizationMode = () => {
  const mode = getCustomMode();
  const activeSides = getActivePrintSides();
  const showGraphic = modeNeedsGraphic();
  const showText = modeNeedsText();

  document.querySelectorAll('[data-upload-side]').forEach((panel) => {
    const side = panel.dataset.uploadSide;
    const sideActive = activeSides.includes(side);
    const graphicControls = panel.querySelectorAll('[data-graphic-control]');
    const textControls = panel.querySelectorAll('[data-text-control]');
    const textInput = panel.querySelector(`[data-custom-text="${side}"]`);
    const generatedTextFile = panel.querySelector(`[data-generated-text-file="${side}"]`);
    const sizeControl = panel.querySelector(`[data-custom-size="${side}"]`);
    const widthControl = panel.querySelector(`[data-custom-width="${side}"]`);
    const hint = panel.querySelector(`[data-side-hint="${side}"]`);
    const previewImage = document.querySelector(`[data-custom-preview-image="${side}"]`);

    graphicControls.forEach((control) => {
      control.hidden = !showGraphic;
      control.style.display = showGraphic ? '' : 'none';
      control.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !sideActive || !showGraphic;
      });
    });

    textControls.forEach((control) => {
      control.hidden = !showText;
      control.style.display = showText ? '' : 'none';
      control.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !sideActive || !showText;
      });
    });

    if (generatedTextFile) {
      generatedTextFile.disabled = !sideActive || !showText;
    }

    if (textInput) {
      textInput.maxLength = isComboMode() ? 24 : 220;
      textInput.rows = isComboMode() ? 1 : 3;
      textInput.placeholder = isComboMode()
        ? 'Es. nome'
        : 'Scrivi una frase. Puoi andare a capo.';
    }

    if (sizeControl) {
      sizeControl.max = isComboMode() ? 110 : 260;
      if (isComboMode() && Number(sizeControl.value) > 80) sizeControl.value = 65;
    }

    if (widthControl) {
      widthControl.max = isComboMode() ? 145 : 220;
      if (isComboMode() && Number(widthControl.value) > 130) widthControl.value = 105;
    }

    if (!showGraphic && previewImage) {
      previewImage.hidden = true;
      previewImage.removeAttribute('src');
    }

    if (hint) {
      hint.textContent = mode === 'Grafica caricata'
        ? 'Carica il file da stampare. I controlli testo restano nascosti.'
        : mode === 'Solo testo'
          ? 'Scrivi il testo: lo riceveremo anche come PNG trasparente 25 x 33 cm.'
          : 'Carica la grafica e aggiungi solo una scritta breve, ad esempio un nome.';
    }

    panel.classList.toggle('is-combo-mode', isComboMode());
    updateCustomTextPreview(side);
  });
};

document.querySelectorAll('[data-customizer]').forEach((customizer) => {
  document.querySelectorAll('[data-custom-file]').forEach((fileInput) => {
    const side = fileInput.dataset.customFile;
    const previewImage = customizer.querySelector(`[data-custom-preview-image="${side}"]`);
    const previewText = customizer.querySelector(`[data-custom-preview-text="${side}"]`);

    if (!previewImage) return;

    fileInput.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file || !file.type.startsWith('image/')) {
        previewImage.hidden = true;
        previewImage.removeAttribute('src');
        updateCustomTextPreview(side);
        return;
      }

      const imageUrl = URL.createObjectURL(file);
      previewImage.src = imageUrl;
      previewImage.hidden = false;
      if (previewText && !isComboMode()) previewText.hidden = true;
      updateCustomTextPreview(side);
    });
  });

  document.querySelectorAll('[data-custom-text]').forEach((textInput) => {
    const side = textInput.dataset.customText;

    textInput.addEventListener('input', () => {
      updateCustomTextPreview(side);
      const previewImage = customizer.querySelector(`[data-custom-preview-image="${side}"]`);
      const value = textInput.value.trim();
      if (value && previewImage && !isComboMode()) previewImage.hidden = true;
    });
  });

  document.querySelectorAll('[data-custom-font], [data-custom-size], [data-custom-width], [data-custom-align], [data-custom-color]').forEach((control) => {
    const side = control.dataset.customFont || control.dataset.customSize || control.dataset.customWidth || control.dataset.customAlign || control.dataset.customColor;
    control.addEventListener('input', () => updateCustomTextPreview(side));
    control.addEventListener('change', () => updateCustomTextPreview(side));
    updateCustomTextPreview(side);
  });
});

document.querySelectorAll('[data-shirt-color]').forEach((button) => {
  button.addEventListener('click', () => {
    const color = button.dataset.shirtColor;
    const form = button.closest('form');
    const colorInput = form?.querySelector('[data-shirt-color-input]');
    const preview = document.querySelector('.shirt-preview');

    form?.querySelectorAll('[data-shirt-color]').forEach((item) => {
      item.classList.remove('is-selected');
    });
    button.classList.add('is-selected');

    if (colorInput) colorInput.value = color;

    if (preview) preview.classList.toggle('is-white-shirt', color === 'Bianco');
    updateCustomPrintPosition();
  });
});

document.querySelectorAll('[data-underwear-model]').forEach((button) => {
  button.addEventListener('click', () => {
    const model = button.dataset.underwearModel || 'Mutanda';

    document.querySelectorAll('[data-underwear-model]').forEach((item) => {
      item.classList.remove('is-selected');
    });
    button.classList.add('is-selected');
    setUnderwearModel(model);
  });
});

document.querySelectorAll('[data-print-position]').forEach((select) => {
  select.addEventListener('change', updateCustomPrintPosition);
});

document.querySelectorAll('[data-custom-mode]').forEach((select) => {
  select.addEventListener('change', updateCustomizationMode);
  select.addEventListener('input', updateCustomizationMode);
});

updateCustomPrintPosition();
setUnderwearModel(document.querySelector('[data-underwear-model].is-selected')?.dataset.underwearModel || 'Mutanda');

document.querySelectorAll('form[action*="/cart/add"], form.product-form, form.product-purchase-form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    if (!window.fetch || !form.querySelector('input[name="id"]')) return;

    if (form.classList.contains('normal-submit-form') || form.querySelector('input[type="file"]')) {
      event.preventDefault();
      if (!validateCustomProductForm(form)) return;

      const submitButton = form.querySelector('[type="submit"]');
      const originalLabel = submitButton?.textContent;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = BAZINGA_R2_ENABLED ? 'Caricamento originali...' : 'Preparazione...';
      }
      try {
        if (form.classList.contains('custom-product-form')) {
          await attachGeneratedTextPngs(form);
          if (BAZINGA_R2_ENABLED) await prepareBazingaR2Uploads(form);
        }
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        showCartToast(error.message || 'Errore durante la preparazione del file.', 'Caricamento non riuscito');
        if (BAZINGA_R2_ENABLED) window.turnstile?.reset?.();
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      }
      return;
    }

    event.preventDefault();
    const submitButton = form.querySelector('[type="submit"]');
    const originalText = submitButton?.textContent;

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Aggiungo...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('cart add failed');

      const item = await response.json();
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = cartResponse.ok ? await cartResponse.json() : null;
      const cartCount = document.querySelector('.cart-link span');

      if (cart && cartCount) cartCount.textContent = cart.item_count;
      showCartToast(`${item.product_title || 'Prodotto'} aggiunto correttamente.`);
    } catch (error) {
      showCartToast('Non sono riuscito ad aggiungere il prodotto. Riprova.', 'Errore carrello');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    }
  });
});

document.querySelectorAll('.product-card .button-product:not([type="submit"])').forEach((button) => {
  button.addEventListener('click', (event) => {
    if (event.button !== 0) return;

    const card = button.closest('.product-card');
    const title = card?.querySelector('.product-title')?.textContent?.trim() || 'Prodotto';
    const selectedSize = card?.querySelector('.is-selected')?.textContent?.trim() || 'XS';
    showCartToast(`${title} taglia ${selectedSize} aggiunto correttamente.`);
  });
});

document.querySelectorAll('[data-checkout-confirm]').forEach((checkbox) => {
  const form = checkbox.closest('form');
  const checkoutButton = form?.querySelector('[data-checkout-button]');
  const warning = form?.querySelector('[data-checkout-warning]');

  if (!form || !checkoutButton) return;

  const updateCheckoutState = () => {
    // Il consenso del cliente non deve mai riabilitare un checkout
    // che il controllo R2 ha bloccato o non ha ancora verificato.
    const r2Ok = checkoutButton.dataset.bazingaR2Ready !== 'checking' &&
                 checkoutButton.dataset.bazingaR2Ready !== 'blocked';
    checkoutButton.disabled = !checkbox.checked || !r2Ok;
    checkoutButton.setAttribute('aria-disabled', String(!checkbox.checked || !r2Ok));
    if (warning) warning.hidden = checkbox.checked;
  };

  checkbox.addEventListener('change', updateCheckoutState);
  updateCheckoutState();
});
